import { render } from "./ComboSection.vue?vue&type=template&id=a62117c0&scoped=true"
import script from "./ComboSection.vue?vue&type=script&lang=js"
export * from "./ComboSection.vue?vue&type=script&lang=js"

import "./ComboSection.vue?vue&type=style&index=0&id=a62117c0&scoped=true&lang=css"

import exportComponent from "/Users/bellakwon/Desktop/thesis01/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a62117c0"]])

export default __exports__